// extracted by mini-css-extract-plugin
module.exports = {"title":"WorkflowActionPanel_title__24WjS","icon":"WorkflowActionPanel_icon__3MfMX"};